import { RiffleApplication } from './js/applications/riffle/index.js';
import EventEmitter from './pkg/utils/EventEmitter.js';

let animation = null;

async function init () {
  const canvas = document.getElementById('scene-canvas');
  if (!canvas) return;

  if (window.innerWidth > 1024) {

    if (animation) return;

    const container = document.getElementById('scene-container');
    const modelURL = container.getAttribute('data-model-url');

    if (animation === null) {
      const emitter = new EventEmitter();
      animation = new RiffleApplication(emitter);
    }

    await animation.build(canvas, container);

    if (animation.loadedModel === null) {
      await animation.loadModel(modelURL);
    }

    animation.mount();

  } else {

    if (animation === null) return;

    animation.unmount();
    animation = null;
  }
}

let resizeTimeout = null;
function onResizeDebounced() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(async () => {
    await init();
  }, 100);
}

window.addEventListener("load", init);

document.addEventListener('swupcontentreplaced', async () => {
  if (animation) {
    animation.unmount();
    animation = null;
  }
  await init();
});

window.addEventListener('resize', onResizeDebounced)

// window.addEventListener("orientationchange", () => {
//   setTimeout(async () => {
//     await init()
//   }, 100)
// });
